module.exports = __webpack_public_path__ + "2d2b34eca46581301f8946a9c7676f0c.png";